import { themeGet } from '@styled-system/theme-get';

import type { EmotionTheme } from '../types/emotion-theme';

interface GetColorProps {
  /** The color you want to translate
   * coolGrey.100 => return theme color
   */
  color?: string;
  /** The fallback color if color doesn't exist in the theme.
   * @default 'primary'
   */
  fallbackColor?: string;
  /** The theme object to translation colors from. */
  theme: EmotionTheme;
}

const getColor = ({ color, fallbackColor = 'primary', theme }: GetColorProps) => {
  if (color?.includes('.')) {
    return `${themeGet(`colors.${color}`, `${fallbackColor}`)({ theme })}`;
  }

  return color;
};

export default getColor;
